<div class="container">
    <H1>View Users</H1>

    <div style="padding-top: 15px;width: 300px;text-align: left;" > 
      <label>Search:</label>
      <div class="input-group mb-3">
        <input class="form-control" ID="details" name="details" type="text" [(ngModel)]="SearchValue" placeholder="Type in something to search"/>
        <div class="input-group-append">
          <button class="btn btn-outline-secondary btnClear" type="button" id="button-addon2" (click)="ClearSearch()">X</button>
        </div>
      </div>
      <div>
        <button class="btn btn-success" type="button" id="button-addon2" (click)="btnDownloadReportClickExcel()">Export</button>
        <button class="btn btn-primary" type="button" id="button-addon2" (click)="Add()" style="margin-left: 20px;">Add</button>
      </div>
       
    </div> 

   


    <table class="viewDataTable" ID="tblData">
    <thead>
        <tr>
          <th class="viewDataTableHeading"></th>
          <th class="viewDataTableHeading">UserName</th>
          <th class="viewDataTableHeading">Rights</th>
        </tr>
    </thead>

        <tr *ngFor="let data of data | filter:SearchValue| paginate: { itemsPerPage: ItemsPerPage, currentPage: p }">
            <td class="viewDataTableCell">
                <button type="submit" class="btn btn-primary btn-lg btn-block"  ID="btnViewData" (click)="EditData(data.ID)">Edit</button>
            </td>
            <td class="viewDataTableCell">{{data.ID}}</td>
            <td class="viewDataTableCell">{{data.Rights}}</td>
        </tr>

      </table>

      <pagination-controls (pageChange)="p = $event"></pagination-controls>


      <table class="viewDataTable" ID="tblDataExport" style="display: none;">
        <thead>
            <tr>
              <th class="viewDataTableHeading">UserName</th>
              <th class="viewDataTableHeading">Rights</th>
            </tr>
        </thead>
    
            <tr *ngFor="let data of data | filter:SearchValue">
                <td class="viewDataTableCell">{{data.ID}}</td>
                <td class="viewDataTableCell">{{data.Rights}}</td>
            </tr>
    
          </table>
      

</div>


<!--Error popup-->
<div style="float: right;margin-left:20px;">
  <button class="btn btn-success btn-lg btn-block" id="ErrorButton" (click)="open(content)" style="display: none;">
  </button>
</div>
 <ng-template #content let-modal ID="Errormessage">
      <div class="modal-header">
          <h4 class="modal-title" 
              id="modal-basic-title">
              {{PopupTitle}}
          </h4>
          <button type="button" class="close"
                  aria-label="Close" (click)=
                  "modal.dismiss('Cross click')">
    
              <span aria-hidden="true">
                  ×
              </span>
          </button>
      </div>
      <div class="modal-body">
          <form>
              <div class="form-group">
                  <label for="dateOfBirth">
                      {{DisplayErrormessage}}
                  </label>
              </div>
          </form>
      </div>
      <div class="modal-footer">
          <button type="button" 
              class="btn btn-success btn-lg btn-block" 
              (click)="modal.close('Save click')">
              Done
          </button>
      </div>
  </ng-template>
